import CardCredentialOtpScreen from 'features/cardManagement/screens/cardCredentialChallenge/CardCredentialOtpScreen/CardCredentialOtpScreen';
import React from 'react';

export default function MoveMoneyP2PCardCredentialOtpPage() {
  return <CardCredentialOtpScreen returnPath="/move-money/p2p/debit" />;
}
